"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentSettingsOut = void 0;
class EnvironmentSettingsOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EnvironmentSettingsOut.attributeTypeMap;
    }
}
exports.EnvironmentSettingsOut = EnvironmentSettingsOut;
EnvironmentSettingsOut.discriminator = undefined;
EnvironmentSettingsOut.attributeTypeMap = [
    {
        "name": "colorPaletteDark",
        "baseName": "colorPaletteDark",
        "type": "CustomColorPalette",
        "format": ""
    },
    {
        "name": "colorPaletteLight",
        "baseName": "colorPaletteLight",
        "type": "CustomColorPalette",
        "format": ""
    },
    {
        "name": "customColor",
        "baseName": "customColor",
        "type": "string",
        "format": ""
    },
    {
        "name": "customFontFamily",
        "baseName": "customFontFamily",
        "type": "string",
        "format": ""
    },
    {
        "name": "customFontFamilyUrl",
        "baseName": "customFontFamilyUrl",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "customLogoUrl",
        "baseName": "customLogoUrl",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "customThemeOverride",
        "baseName": "customThemeOverride",
        "type": "CustomThemeOverride",
        "format": ""
    },
    {
        "name": "displayName",
        "baseName": "displayName",
        "type": "string",
        "format": ""
    },
    {
        "name": "enableChannels",
        "baseName": "enableChannels",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enableIntegrationManagement",
        "baseName": "enableIntegrationManagement",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enableMessageTags",
        "baseName": "enableMessageTags",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enableTransformations",
        "baseName": "enableTransformations",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "showUseSvixPlay",
        "baseName": "showUseSvixPlay",
        "type": "boolean",
        "format": ""
    }
];
//# sourceMappingURL=EnvironmentSettingsOut.js.map